import React from 'react'

export default class Pusher extends React.Component {
  static propTypes = {}

  componentDidMount() {
    // Enable pusher logging - don't include this in production
    // global.Pusher.logToConsole = true

    if (!global.pusher) {
      var pusher = new global.Pusher('ce386deb63691b2f671c', {
        cluster: 'us2',
        forceTLS: true
      })

      global.pusher = pusher
    } else {
      console.log('connecting again')
      global.pusher.connect()
    }
  }

  componentWillUnmount() {
    console.log('disconnecting')
    global.pusher.disconnect()
  }

  render() {
    return <span />
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Exchange/Layout/Pusher/index.js